import { Box, Button, Checkbox, TableCell, TableRow, Typography } from '@mui/material';
import JM from 'jalali-moment';
import { forwardRef } from 'react';
import Iconify from 'src/components/Iconify';
import Label from 'src/components/Label';
import { MyAvatar } from 'src/components/common';

// ----------------------------------------------------------------------

const MediaRewardsTableRow = forwardRef((props, ref) => {
  const {
    row,
    rowNumber,
    selected,
    onSelectRow,
    onEditRow,
    onDeleteRow,
    openLeaderboardModal,
    isDragging,
    isDraggable,
    setSelectedRow,
    onDeleteRowHandler,
    ...rest
  } = props;

  const {
    TransactionAmountTypeLable,
    MediaRewardsTimeCount,
    MeidaRewardsValue,
    MediaRewardsScore,
    MediaRewardsClubPoint,
    MediaRewardsUserLevel,
    MediaRewardsID,
  } = row;

  return (
    <TableRow
      hover
      selected={selected}
      ref={ref}
      style={{
        width: '100%',
        background: isDragging ? '#f4f6f8' : '',
        ...rest.style,
      }}
      {...rest}
    >
      <TableCell></TableCell>
      <TableCell align="center">
        <Typography variant="body2">{rowNumber}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2">{TransactionAmountTypeLable}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2">{MediaRewardsTimeCount}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2">{MeidaRewardsValue}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography variant="body2">{MediaRewardsScore}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography variant="body2">{MediaRewardsClubPoint}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography variant="body2">{MediaRewardsUserLevel}</Typography>
      </TableCell>

      {/* <TableCell align="center">
        <Typography variant="body2">{Number(DuelMinimumScore)}</Typography>
      </TableCell> */}

      <TableCell align="right">
        <Box sx={{ display: 'inline-flex', gap: 1 }}>
          <Button size="small" color="info" variant="contained" onClick={onEditRow}>
            ویرایش
          </Button>

          <Button size="small" color="error" variant="contained" onClick={() => onDeleteRowHandler(MediaRewardsID)}>
            حذف
          </Button>
        </Box>
      </TableCell>
    </TableRow>
  );
});

export default MediaRewardsTableRow;
